import AppProvider from 'providers/AppProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import BreakpointsProvider from 'providers/BreakpointsProvider';
import SettingsPanelProvider from 'providers/SettingsPanelProvider';
import { RouterProvider } from 'react-router-dom';
import { router } from 'routes/Routes';
import { Provider } from 'react-redux';
import store from 'store';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GoogleOAuthProvider clientId="47526618523-6g1q8dvjbkdjl6rhoo03q8rmfqnu3bko.apps.googleusercontent.com">
        <AppProvider>
          <SettingsPanelProvider>
            {/* <ChatWidgetProvider> */}
              <BreakpointsProvider>
                <RouterProvider router={router} />
              </BreakpointsProvider>
            {/* </ChatWidgetProvider> */}
          </SettingsPanelProvider>
        </AppProvider>
      </GoogleOAuthProvider>
      <Toaster />
    </Provider>
  </React.StrictMode>
);
